const hostUser=process.env.NODE_ENV === 'production'?'https://user.hinabian.com':''
const hostApi=process.env.NODE_ENV === 'production'?'https://api.hinabian.com':'/api'
const Url={
    loginMobile: hostUser+'/user/index/loginMobile', // 手机号验证码登录
    smsVcodeUrl: hostUser+'/user/index/vcode', // 发送短信验证码
    overseaCountry:hostApi+'/projects/oversea/country',//出海国家列表
}
export default Url